import {
  POSTS_LIST, CREATE, POSTS_LIST_NEXT, CC_UPDATES_LIST, USER_WALL_POSTS, DELETE, DELETESHARED, UPDATE, UPDATESHARED,
  CREATEMEDIA, DELETEMEDIA, UPDATEMEDIA,
} from './types';

export default {
  [POSTS_LIST]: (state, { posts, page }) => {
    if (page === 1) {
      state.posts = [...posts];
    } else {
      state.posts = [...state.posts, ...posts];
    }
  },
  [USER_WALL_POSTS]: (state, { userWall, page }) => {
    if (page === 1) {
      state.userWall = [...userWall];
    } else {
      state.userWall = [...state.userWall, ...userWall];
    }
  },
  [CC_UPDATES_LIST]: (state, payload) => {
    state.ccUpdates = payload.ccUpdates;
  },
  [POSTS_LIST_NEXT]: (state, payload) => {
    state.posts = [...state.posts, ...payload.posts];
  },
  [CREATE]: (state, payload) => {
    state.posts = [payload.post, ...state.posts];
  },
  [DELETE]: (state, payload) => {
    state.posts = state.posts.filter(({ id }) => id !== payload.postId);
    state.userWall = state.userWall.filter(({ post_details }) => post_details.id !== payload.postId);
  },
  [DELETESHARED]: (state, payload) => {
    state.posts = state.posts.filter(({ shared_post_id }) => shared_post_id !== payload.postId);
    state.userWall = state.userWall.filter(({ shared_post_id }) => shared_post_id !== payload.postId);
  },
  [UPDATE]: (state, payload) => {
    if (state.userWall.length) {
      const postIndex1 = state.userWall.findIndex(({ post_details }) => post_details.id === payload.id);
      state.userWall[postIndex1].post_details = payload;
      state.userWall = [...state.userWall];
    }

    if (state.posts.length) {
      const postIndex2 = state.posts.findIndex(post => post.id === payload.id);
      state.posts[postIndex2] = payload;
      state.posts = [...state.posts];
    }
  },
  [UPDATESHARED]: (state, payload) => {
    if (state.userWall.length) {
      const postIndex1 = state.userWall.findIndex(({ shared_post_details }) => shared_post_details.url === payload.url);
      state.userWall[postIndex1].shared_post_details = payload;
      state.userWall[postIndex1].description = payload.description;
      state.userWall = [...state.userWall];
    }
    if (state.posts.length) {
      const postIndex2 = state.posts.findIndex(({ url }) => url === payload.url);
      state.posts[postIndex2] = payload;
      state.posts = [...state.posts];
    }
  },
  [CREATEMEDIA]: (state, payload) => {
    if (state.userWall.length) {
      const postIndex1 = state.userWall.findIndex(({ post_details }) => post_details.url === payload.post);
      state.userWall[postIndex1].post_details.media.push(payload);
      state.userWall = [...state.userWall];
    }

    if (state.posts.length) {
      const postIndex2 = state.posts.findIndex(post => post.url === payload.post);
      state.posts[postIndex2].media.push(payload);
      state.posts = [...state.posts];
    }
  },
  [UPDATEMEDIA]: (state, payload) => {
    if (state.userWall.length) {
      const postIndex1 = state.userWall.findIndex(({ post_details }) => post_details.url === payload.post);
      state.userWall = [...state.userWall];
      state.userWall[postIndex1].post_details.media = [payload];
      state.userWall[postIndex1].media = [payload];
    }

    if (state.posts.length) {
      const postIndex2 = state.posts.findIndex(post => post.url === payload.post);
      state.posts = [...state.posts];
      state.posts[postIndex2].media = [payload];
    }
  },
  [DELETEMEDIA]: (state, payload) => {
    if (state.userWall.length) {
      const postIndex1 = state.userWall.findIndex(({ post_details }) => post_details.url === payload.post);
      const media = state.userWall[postIndex1].post_details.media.filter(({ id }) => id !== payload.id);
      state.userWall[postIndex1].post_details.media = media;
      state.userWall[postIndex1].media = media;

      state.userWall = [...state.userWall];
    }

    if (state.posts.length) {
      const postIndex2 = state.posts.findIndex(post => post.url === payload.post);

      state.posts[postIndex2].media = state.posts[postIndex2].media.filter(id => id !== payload.id);

      state.posts = [...state.posts];
    }
  },
};
